import { useEffect, useState } from 'react';
import { Typography } from '@blofin/blofin-ui';
import ActivityCard from '../ActivityCard';

type ActivityWrapperProps = {
  title: string;
  list: ActivityItem[];
  className: string;
};

export default function ActivityWrapper({ title, list, className }: ActivityWrapperProps) {
  const [client, setClient] = useState(false);

  useEffect(() => {
    if (list.length) {
      setClient(true);
    }
  }, [list.length]);

  if (!client) {
    return null;
  }

  return (
    <article className={className}>
      <Typography variant="h5" weight="bold" className="leading-tight">
        {title}
      </Typography>
      <div className="mt-[52px] flex flex-col gap-[44px] md:mt-[40px] md:gap-[64px]">
        {list.map((item) => (
          <ActivityCard key={item.activity_id} {...item} />
        ))}
      </div>
    </article>
  );
}
